import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const QINETIC_PAYMENT_SOURCES_API_NAME: string = 'qinetic_payment_sources';
export const QINETIC_PAYMENT_SOURCES_API_ENDPOINT: string = environment.API_BASE_PATH + '/buyer-qinetic-payment-source';

@Injectable({
  providedIn: 'root',
})
export class QineticPaymentSourcesService {
  listPaymentSources(buyer_id: string): Observable<any> {
    const api_name: string = QINETIC_PAYMENT_SOURCES_API_NAME;
    const path: string = `/buyer/${buyer_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  updatePaymentSource(
    buyer_qinetic_payment_source_id: string,
    buyer_id: string,
    payload: { iban: string; order_id?: string; store_id?: string },
  ): Observable<any> {
    const api_name: string = QINETIC_PAYMENT_SOURCES_API_NAME;
    const path: string = `/${buyer_qinetic_payment_source_id}/buyer/${buyer_id}`;
    const init = {
      response: true,
      body: payload,
    };
    return from(API.put(api_name, path, init));
  }
}

export interface QineticPaymentSource {
  buyer_qinetic_payment_source_id?: string;
  buyer_id?: string;
  qinetic_sepa_debit?: QineticSepaDebit;
  is_default_source?: boolean;
}

export interface QineticSepaDebit {
  fingerprint?: string;
  bank_code?: string;
  country?: string;
  iban?: string;
  last4?: string;
}
